<template>
  <div class="side-menu" ref="sideMenu">
    <div class="expand-icon" @click="toggleSideMenu()">
      <v-icon color="white" v-show="!this.sideActive"
        >mdi-arrow-collapse-down</v-icon
      >
      <v-icon color="white" v-show="this.sideActive"
        >mdi-arrow-collapse-up</v-icon
      >
    </div>
    <DistrictSearch ref="search" />
    <!-- <HoverDataDisplay v-show="!this.dataSelected"/> -->
    <div class="load-overlay" v-show="this.$store.getters.getLoading">
      <!--  -->
      <v-progress-circular :size="84" color="var(--imperial-red)" indeterminate>
      </v-progress-circular>
    </div>
    <!-- <div class="clean-side-bg"></div> -->

    <div
      class="district-data-container"
      v-show="this.dataSelected || this.$store.getters.getLoading"
      ref="dataContainer"
    >
      <SelectedDataDisplay />
    </div>
    <div v-show="!this.$store.getters.getLoading">
      <SideStateLegEmpty
        v-show="
          this.districtType !== Enums.LEG_BODY.CONGRESS && !this.dataSelected
        "
      />
      <SideCongressEmpty
        v-show="
          this.districtType === Enums.LEG_BODY.CONGRESS && !this.dataSelected
        "
      />

      <!-- <div
        v-show="!this.dataSelected && !this.$store.getters.isMobile"
        class="resize-icon"
      >
        Drag corner to expand<v-icon color="grey"
          >mdi-arrow-collapse-right</v-icon
        >
      </div> -->
    </div>
  </div>
</template>
<script>
import DistrictSearch from "../../DistrictSearch";
import SelectedDataDisplay from "../../DataDisplay/SelectedDataDisplay.vue";
// import HoverDataDisplay from '../../DataDisplay/HoverDataDisplay.vue';
import SideStateLegEmpty from "./SideStateLegEmpty.vue";
import SideCongressEmpty from "./SideCongressEmpty.vue";

import { Enums } from "../../../data/Config/Config";
import { EventBus } from "../../../data/EventBus";

export default {
  name: "SideMenu",
  components: {
    DistrictSearch,
    SelectedDataDisplay,
    // HoverDataDisplay,
    SideStateLegEmpty,
    SideCongressEmpty,
  },
  data: function () {
    return {
      Enums: Enums,
      styleObject: {
        color: "red",
        fontSize: "13px",
      },
    };
  },
  mounted: function () {},
  computed: {
    dataSelected: function () {
      return Object.entries(this.$store.getters.getSelectedData).length > 0;
    },
    districtType: function () {
      return this.$store.getters.getDistrictType;
    },
    sideActive: {
      get: function () {
        return this.$store.getters.getSidePanelOpen;
      },
      set: function (newValue) {
        this.$store.commit("setSidePanelOpen", newValue);
      },
    },
  },
  methods: {
    toggleSideMenu: function () {
      this.sideActive = !this.sideActive;
    },
    clearResults() {
      this.$store.commit("setSelectedData", {});
      this.$store.commit("setSelectedPoint", {});
      this.$store.commit("setSelectedAddress", {});
      EventBus.$emit("clear-data");
    },
  },
};
</script>
<style scoped>
.load-overlay {
  width: 100%;
  /* height: 100%; */
  top: 50%;
  text-align: center;
  position: absolute;
  z-index: 5;
  background: transparent;
}

.clean-side-bg {
  overflow-wrap: anywhere;
  position: absolute;
  /* border-top: 1px solid lightgray; */
  top: 100px;
  bottom: 0;
  left: 0;
  width: 100%;
  /* width: 20%; */
  z-index: 0;
  background: var(--honeydew);
}

@keyframes show-side-anim {
  from {
    height: 100px;
    opacity: 1;
  }
  to {
    height: 100%;
    opacity: 1;
  }
}
.search-district {
  margin: 0;
  top: 10px;
  margin-left: -10px;
}

.side-menu.hideSide {
  resize: none;
}
.hideSide .search-district {
  position: absolute;
  width: 100%;
}

.expand-icon {
  position: absolute;

  top: 5px;
  bottom: auto;
  right: 5px;
}

.expand-icon:hover {
  cursor: pointer;
}

.side-menu {
  color: var(--color-dark);
  background-color: var(--prussian-blue);
  /* background-color: var(--burnt-sienna); */
  /* opacity: 1; */
  position: absolute;
  top: 64px;
  bottom: 0;
  animation-name: show-side-anim;
  animation-duration: 0.5s;
  left: 0;
  /* width: 20%; */
  /* width: 25%; */
  /* width: 28%; */
  width: 410px;
  max-width: 67%;
  min-width: 300px;
  z-index: 1;
  box-shadow: -8px 0px 26px black;
  overflow-y: inherit;
  overflow-x: hidden;
  /* resize: horizontal; */
  caret-color: transparent;
}
.resize-icon {
  position: absolute;
  bottom: 0;
  right: 17px;
  text-align: right;
  padding: 0 5px;
  /* color: var(--celadon-blue); */
  font-size: 14px;
  z-index: 3;
  background: white;
  padding: 5px 10px;
  opacity: 0.8;
  font-weight: 900;
}

.hideSide .resize-icon {
  display: none;
}

.hideSide .load-overlay {
  top: 7px;
}
.district-data-container {
  overflow-wrap: anywhere;
  overflow-y: scroll;
  position: absolute;

  /* border-top: 1px solid lightgray; */
  top: 100px;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  background: var(--honeydew);
  /* background: var(--light-peach-puff); */
}

.v-icon.mdi-magnify-plus {
  font-size: 24px;
}
</style>

<style>
.selected-district-data-item {
  /* padding: 20px; */
  padding: 15px;
  margin-top: 110px;
  background: var(--honeydew);
  overflow-y: scroll;
  bottom: 0px;
  top: 0px;
  position: absolute;
}

.zoom-btn.zoom .v-btn__content {
  display: inline;
}

.zoom-btn.zoom {
  left: 5px;
}
</style>

// .vjs-loading-spinner {
//     animation: spin 1.5s linear infinite;
//     background: transparent;
//     clip: rect(0,64px,64px,32px);
//     display: none;
//     margin: -32px 0 0 -32px;
//     opacity: .9;
//     position: absolute;
//     left: 50%;
//     top: 50%;
//     width: 64px;
//     height: 64px;
//     z-index: 4000
// }

// .ad-loading:not(.force-paused) .vjs-loading-spinner,.vjs-seeking .vjs-loading-spinner,.vjs-waiting:not(.vjs-error) .vjs-loading-spinner {
//     display: block
// }

// .vjs-loading-spinner:after {
//     animation: spin2 1.5s ease-in-out infinite;
//     border-radius: 50%;
//     clip: rect(0,64px,64px,32px);
//     content: "";
//     position: absolute;
//     width: 64px;
//     height: 64px;
//     top: 0;
//     left: 0
// }

// .vjs-loading-spinner .vjs-control-text {
//     display: none
// }

// @keyframes spin {
//     0% {
//         transform: rotate(0deg)
//     }

//     to {
//         transform: rotate(220deg)
//     }
// }

// @keyframes spin2 {
//     0% {
//         box-shadow: inset 0 0 0 12px #c33;
//         transform: rotate(-140deg)
//     }

//     50% {
//         box-shadow: inset 0 0 0 2px #c33
//     }

//     to {
//         box-shadow: inset 0 0 0 12px #c33;
//         transform: rotate(140deg)
//     }
// }